import React from 'react';
import IconBase from './IconBase';
const CautionIcon = props => React.createElement(IconBase, props, React.createElement("line", {
  x1: "32",
  y1: "19.9",
  x2: "32",
  y2: "37.5",
  strokeWidth: "6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none"
}), React.createElement("line", {
  x1: "32",
  y1: "46.9",
  x2: "32",
  y2: "48.4",
  strokeWidth: "6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none"
}), React.createElement("path", {
  strokeWidth: "5.9794",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none",
  d: "M35.6,5.8L60.2,51c0.7,1.3,0.7,2.7-0.1,4c-0.4,0.6-0.9,1.1-1.5,1.5c-0.6,0.4-1.3,0.5-2,0.5H7.3 c-0.7,0-1.4-0.2-2-0.5c-0.6-0.4-1.1-0.9-1.5-1.5C3,53.7,3,52.4,3.7,51L28.4,5.8c0.4-0.7,0.9-1.2,1.5-1.6s1.3-0.6,2.1-0.6 c0.7,0,1.4,0.2,2.1,0.6C34.7,4.6,35.2,5.2,35.6,5.8z"
}));
CautionIcon.displayName = 'CautionIcon';
export default CautionIcon;
//# sourceMappingURL=CautionIcon.js.map